import styled from 'styled-components'
import { Section } from 'style'

export const StyledDiv = styled(Section)`
  flex-direction: row;
`
